
<div v-if="fullScreen" class="overlay flex-center">
  <InlineLoader />
  <h3>Loading...</h3>
</div>
<InlineLoader v-else />
